import http from '@/utils/http'
// import { ListSearchReq, ListSearchRes, RovinceReq, RovinceRes, RecommendReq, RecommendRes } from './types/other'

/**
 * 商品列表接口
 */
const listApi = {

  // 获取热门推荐
  getHotList(RecommendReq: any) {
    return http.post<any>('/business/promotion/getBusinessResources', RecommendReq)
  },

  // 获取资源类目
  getCategoryList() {
    return http.get<any>('/business/businessResource/findCategory')
  },

  // 获取省份接口
  getProvinceList() {
    return http.get<any>('/geo/findAllProvince')
  },

  // 根据省份id 获取市区
  findCitys(params: any) {
    return http.post<any>('/geo/findCitiesByProvinceIds', params)
  },

  // 搜索数据
  getSearchData(ListSearchReq: any) {
    return http.post<any>('/business/homePage/getResourceListFromEs', ListSearchReq)
  }

}
export default listApi